export const LOCAL_STORAGE_KEYS = {
  AUTH_TOKEN: 'auth.token',
  AUTH_IS_AGENT: 'auth.isAgent',
  AUTH_REFRESH_TOKEN: 'auth.refreshToken',
  COUNTRY: 'country',
}